import _ from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function unflattenObject(flattedObject: any) {
  const result = {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _.keys(flattedObject).forEach((key, value) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    _.set(result, key, flattedObject[key]);
  });
  return result;
}
